import ViewUtil from "../../../ViewUtil";
import { RepoItem } from "../../../autogenerated/ZoomBridge";
import System from "../../../basic/System";
import { BrowseExtUtil } from "../../../tabs/browse-external/BrowseExtUtil";
import { archiveResolutions, archiveStatusEnum } from "../../../util/Constants";
import FileInfoUtil from "../../../util/FileInfoUtil";
import { getAssetProps } from "../../../util/SelectedItemUtil";
import CollectionUtil from "../../../queries/lightbox/CollectionUtil";
import CollectionSettingsUtil from "../../../queries/lightbox/userRoles/CollectionSettingsUtil";
import MetadataUtil from "../../../util/MetadataUtil";

const isAssetOrSearchTabActive = () => {
  return ViewUtil.isAssetTabActive() || ViewUtil.isSeachTabActive();
}

const containsAnyFolder = (assets) => {
  for (let asset of assets) {
    if (!asset.getBasicFileAttributes().isFile()) return true;
  }
  return false;
}

const containsAnyProxy = (assets) => {
  for (let asset of assets) {
    if (asset.isProxy()) return true;
  }
  return false;
}

const isArchived = (archiveStatus) => {
  let archived = archiveStatus === archiveStatusEnum.VAB_ARCHIVED ||
    archiveStatus === archiveStatusEnum.VAB_COPIED_TO_ARCHIVE ||
    isGlacierArchived(archiveStatus);
  return archived;
}

const isArchivedPending = (archiveStatus) => {
  return archiveStatus === archiveStatusEnum.VAB_PENDING;
}

const isArchivable = (archiveStatus) => {
  return archiveStatus != archiveStatusEnum.VAB_NOT_APPLICABLE;
}

const isGlacierArchived = (archiveStatus) => {
  return archiveStatus === archiveStatusEnum.COPIED_TO_GLACIER;
}

const isArchivedOrPending = (archiveStatus) => {
  return isArchived(archiveStatus) || isArchivedPending(archiveStatus);
}

const isAssetArchivedOrPending = (asset, archiveResolution) => {
  if (asset.isProxy()) {
    switch (archiveResolution) {
      case archiveResolutions.HI_RES:
        const hiResArchiveStatus: string = asset.getHiResArchiveStatus();
        if (isArchivable(hiResArchiveStatus) && isArchivedOrPending(hiResArchiveStatus))
          return true;
        break;
      case archiveResolutions.MID_RES:
        const midResArchiveStatus: string = asset.getMidResArchiveStatus();
        if (isArchivable(midResArchiveStatus) && isArchivedOrPending(midResArchiveStatus))
          return true;
        break;
      case archiveResolutions.LOW_RES:
        const lowResArchiveStatus: string = asset.getLowResArchiveStatus();
        if (isArchivable(lowResArchiveStatus) && isArchivedOrPending(lowResArchiveStatus))
          return true;
      default:
        break;
    }
  }
  return false;
}

const isAssetArchivable = (asset, archiveResolution) => {
  if (asset.isProxy()) {
    switch (archiveResolution) {
      case archiveResolutions.HI_RES:
        const hiResArchiveStatus: string = asset.getHiResArchiveStatus();
        if (isArchivable(hiResArchiveStatus) && !isArchivedOrPending(hiResArchiveStatus))
          return true;
        break;
      case archiveResolutions.MID_RES:
        const midResArchiveStatus: string = asset.getMidResArchiveStatus();
        if (isArchivable(midResArchiveStatus) && !isArchivedOrPending(midResArchiveStatus))
          return true;
        break;
      case archiveResolutions.LOW_RES:
        const lowResArchiveStatus: string = asset.getLowResArchiveStatus();
        if (isArchivable(lowResArchiveStatus) && !isArchivedOrPending(lowResArchiveStatus))
          return true;
      default:
        break;
    }
  }
  return false;
}

const isAssetArchived = (asset, archiveResolution) => {
  if (asset.isProxy()) {
    switch (archiveResolution) {
      case archiveResolutions.HI_RES:
        const hiResArchiveStatus: string = asset.getHiResArchiveStatus();
        if (isArchivable(hiResArchiveStatus) && isArchived(hiResArchiveStatus))
          return true;
        break;
      case archiveResolutions.MID_RES:
        const midResArchiveStatus: string = asset.getMidResArchiveStatus();
        if (isArchivable(midResArchiveStatus) && isArchived(midResArchiveStatus))
          return true;
        break;
      case archiveResolutions.LOW_RES:
        const lowResArchiveStatus: string = asset.getLowResArchiveStatus();
        if (isArchivable(lowResArchiveStatus) && isArchived(lowResArchiveStatus))
          return true;
        break;
      default:
        break;
    }
  }
  return false;
}

const isAssetGlacierArchived = (asset, archiveResolution) => {
  if (asset.isProxy()) {
    switch (archiveResolution) {
      case archiveResolutions.HI_RES:
        const hiResArchiveStatus: string = asset.getHiResArchiveStatus();
        if (isArchivable(hiResArchiveStatus) && isGlacierArchived(hiResArchiveStatus))
          return true;
        break;
      case archiveResolutions.MID_RES:
        const midResArchiveStatus: string = asset.getMidResArchiveStatus();
        if (isArchivable(midResArchiveStatus) && isGlacierArchived(midResArchiveStatus))
          return true;
        break;
      case archiveResolutions.LOW_RES:
        const lowResArchiveStatus: string = asset.getLowResArchiveStatus();
        if (isArchivable(lowResArchiveStatus) && isGlacierArchived(lowResArchiveStatus))
          return true;
        break;
      default:
        break;
    }
  }
  return false;
}

const isShowResolutionTabs = (args, comparatorFunction: Function) => {
  const { assets } = args;
  if (System.isDesktop() && isAssetOrSearchTabActive() && assets.length) {
    if (!containsAnyFolder(assets)) {
      if (containsAnyProxy(assets)) {
        if (assets.length === 1) {
          return assets[0].isProxy() && comparatorFunction(assets[0]);
        } else {
          return true;
        }
      }
      else {
        return false;
      }
    }
    else
      return true;
  }
  else
    return false;
}

export const CM_PREDICATES = {
  default: () => {
    return true;
  },
  isShowCopyAssetID: (args) => {
    const { assets } = args;
    return !ViewUtil.isBrowseExternalTabActive() && assets && assets.length && !FileInfoUtil.isProject(assets[0]) ? true : false;
  },
  isShowCopyAssetPath: (args) => {
    const { assets } = args;
    return !ViewUtil.isBrowseExternalTabActive() && assets && assets.length && !FileInfoUtil.isProject(assets[0]) ? true : false;
  },
  isShowStatus: (args) => {
    const { assets } = args;
    return System.isVAB() && isAssetOrSearchTabActive() && assets && assets.length && !FileInfoUtil.isProject(assets[0]);
  },
  isShowLock: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets);
    const { containsDeleted, containsArchived, containsExpired, lockMenuStatus, containsFolder } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    return isAssetOrSearchTabActive() && !containsNonAliveAsset && !FileInfoUtil.isProject(assets[0]) && (lockMenuStatus === 1 || lockMenuStatus === 0 || containsFolder) ? true : false
  },
  isShowUnLock: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets);
    const { containsDeleted, containsArchived, containsExpired, lockMenuStatus, containsFolder } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    return isAssetOrSearchTabActive() && !containsNonAliveAsset && !FileInfoUtil.isProject(assets[0]) && (lockMenuStatus === 2 || lockMenuStatus === 0 || containsFolder) ? true : false
  },
  isShowCopyAssetURL: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const containsNonAliveAsset = assetProps.containsDeleted || assetProps.containsArchived || assetProps.containsExpired;
    return isAssetOrSearchTabActive() && !containsNonAliveAsset && assets.length === 1
      && !assetProps.containsFolder && !FileInfoUtil.isProject(assets[0]) ? true : false;
  },
  isShowEditMenu: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsFolder, containWCFile, containsDeleted, containsArchived, containsExpired } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    const isSingleAsset = assets.length === 1 ? true : false;
    const isBrowseExternalTab = ViewUtil.isBrowseExternalTabActive();
    return !isBrowseExternalTab && !containsNonAliveAsset && isSingleAsset && System.isVAB()
      && !containsFolder && containWCFile && !FileInfoUtil.isProject(assets[0]) ? true : false;
  },
  isShowDelete: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsDeleted, containsArchived, containsExpired } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    return isAssetOrSearchTabActive() && !containsNonAliveAsset && !FileInfoUtil.isProject(assets[0])
      && !FileInfoUtil.isProject(assets[0]) ? true : false
  },
  isShowAddToCollection: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    return isAssetOrSearchTabActive() && !FileInfoUtil.isProject(assets[0]) && !assetProps.containsFolder
      && !FileInfoUtil.isProject(assets[0]) ? true : false;
  },
  isShowShareAndDownload: (args) => {
    const { assets } = args;
    return isAssetOrSearchTabActive() ? true : false;
  },
  isShowEditMetadata: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsFolder, containsDeleted, containsArchived, containsExpired } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    return ViewUtil.isAssetTabActive() && !containsNonAliveAsset && !containsFolder
      && !FileInfoUtil.isProject(assets[0]) ? true : false
  },
  isShowSmartCopy: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsDeleted, containsArchived, containsExpired } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    return isAssetOrSearchTabActive() && !containsNonAliveAsset ? true : false
  },
  isShowSmartLink: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsDeleted, containsArchived, containsExpired } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    return isAssetOrSearchTabActive() && !containsNonAliveAsset ? true : false
  },
  isShowAddToSpotLight: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsDeleted, containsArchived, containsExpired } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    const isSingleAsset = assets.length === 1 ? true : false;
    return isAssetOrSearchTabActive() && !FileInfoUtil.isProject(assets[0]) && !containsNonAliveAsset
      && isSingleAsset && !ViewUtil.isCollectionTabActive() /*|| this.props.permission.canShowSpotLightAction*/ ? true : false
  },
  isShowAddToFavorite: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsDeleted, containsArchived, containsExpired } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    const isSingleAsset = assets.length === 1 ? true : false;
    const isFav = FileInfoUtil.isFavAsset(assets[0].getFuid());
    return isAssetOrSearchTabActive() && !containsNonAliveAsset && isSingleAsset && !FileInfoUtil.isProject(assets[0])
      && !ViewUtil.isCollectionTabActive() && !isFav /*|| this.props.permission.canShowSpotLightAction*/ ? true : false
  },
  isShowRemoveFromFavorite: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsDeleted, containsArchived, containsExpired } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    const isSingleAsset = assets.length === 1 ? true : false;
    const isFav = FileInfoUtil.isFavAsset(assets[0].getFuid());
    return isAssetOrSearchTabActive() && !containsNonAliveAsset && isSingleAsset && !FileInfoUtil.isProject(assets[0])
      && !ViewUtil.isCollectionTabActive() && isFav ? true : false;
  },
  isShowOpenMenu: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsFolder, containsDeleted, containsArchived, containsExpired, allFromWC } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    const isSingleAsset = assets.length === 1 ? true : false;
    const isBrowseExternalTab = ViewUtil.isBrowseExternalTabActive();
    return !isBrowseExternalTab && !containsNonAliveAsset && isSingleAsset && !FileInfoUtil.isProject(assets[0])
      && !containsFolder && System.isDesktop() && allFromWC ? true : false
  },
  isShowRename: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsDeleted, containsArchived, containsExpired } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    const isSingleAsset = assets.length === 1 ? true : false;
    const isBrowseExternalTab = ViewUtil.isBrowseExternalTabActive();
    return (!isBrowseExternalTab && !containsNonAliveAsset && isSingleAsset /*|| this.props.permission.canRenameCollection*/) &&
      !FileInfoUtil.isProject(assets[0]) ? true : false
  },
  isShowRemoveFromCollection: (args) => {
    const { assets } = args;
    return ViewUtil.isCollectionTabActive()/* || this.props.permission.canRemoveAssets*/ ? true : false
  },
  isShowCompareViewMenu: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsDeleted, containsArchived, containsExpired } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    if (isAssetOrSearchTabActive() && !containsNonAliveAsset && !FileInfoUtil.isProject(assets[0])) {
      if (assets.length !== 2) return false;
      if (FileInfoUtil.isImage(assets[0]) && FileInfoUtil.isImage(assets[1])) return true;
      if (FileInfoUtil.isVideo(assets[0]) && FileInfoUtil.isVideo(assets[1])) return true;
      if (FileInfoUtil.isMultiPage(assets[0]) && FileInfoUtil.isMultiPage(assets[1])) return true;
    }
    return false;
  },
  isShowFolderDetails: (args) => {
    const { assets = [] } = args;
    const assetProps = getAssetProps(assets)
    const { containsFolder } = assetProps;
    const isSingleAsset = assets.length === 1 ? true : false;
    return isSingleAsset && containsFolder ? true : false;
  },
  isShowRemoveWorkingCopy: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { allFromWC } = assetProps;
    return isAssetOrSearchTabActive() && allFromWC && !FileInfoUtil.isProject(assets[0]) ? true : false;
  },
  isShowResurrect: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsDeleted, containsAlive, containsExpired } = assetProps;
    return isAssetOrSearchTabActive() && containsDeleted && !containsExpired && !containsAlive && !FileInfoUtil.isProject(assets[0]) ? true : false;
  },
  isShowInAssetBrowser: (args) => {
    const { assets } = args;
    const isSingleAsset = assets.length === 1 ? true : false;
    return System.isDesktop() && isSingleAsset && !FileInfoUtil.isProject(assets[0]) ? true : false;
  },
  isShowInSystem: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsFolder, containWCFile, containsDeleted, containsArchived, containsExpired, allFromWC, containsAlive } = assetProps;
    const isSingleAsset = assets.length === 1 ? true : false
    return System.isDesktop() && isSingleAsset && allFromWC && !FileInfoUtil.isProject(assets[0]) ? true : false;
  },
  isShowIngestToZoom: () => {
    return ViewUtil.isBrowseExternalTabActive() ? true : false
  },
  isShowRefresh: () => {
    return ViewUtil.isBrowseExternalTabActive() ? true : false
  },
  isShowDetails: (args) => {
    const { extDetails } = args;
    return ViewUtil.isBrowseExternalTabActive() && BrowseExtUtil.isFile(extDetails.node.getType()) ? true : false
  },
  isShowArchiveOption: (args) => {
    const { assets } = args;
    if (System.isDesktop() && isAssetOrSearchTabActive()) {
      if (assets.length) {
        if (FileInfoUtil.isProject(assets[0]))
          return false;
        if (assets.length === 1 && !FileInfoUtil.isFolder(assets[0])) {
          const lowResArchiveStatus: string = assets[0].getLowResArchiveStatus();
          const archived: boolean = assets[0].isArchived();
          if (!assets[0].isProxy()) {
            return archived ? false : true;
          } else {
            return lowResArchiveStatus == archiveStatusEnum.VAB_NOT_ARCHIVED ? true : false;
          }
        } else {
          return true;
        }
      }
      return false;
    }
    else return false

  },
  isShowManageExternalOptions: (args) => {
    const { assets } = args;
    if (System.isDesktop() && isAssetOrSearchTabActive()) {
      if (assets.length > 0) {
        if (assets.length == 1) {
          return !FileInfoUtil.isProject(assets[0]) && containsAnyFolder(assets) ||
            (assets[0].isProxy() && (
              ((isAssetArchived(assets[0], archiveResolutions.HI_RES) && assets[0].extraInfo?.isIsConnected()) ||
                isAssetArchived(assets[0], archiveResolutions.MID_RES)) ||
              ((isAssetArchivable(assets[0], archiveResolutions.HI_RES) && assets[0].extraInfo?.isIsConnected()) ||
                isAssetArchivable(assets[0], archiveResolutions.MID_RES)) ||
              ((isAssetArchived(assets[0], archiveResolutions.HI_RES) && !assets[0].extraInfo?.isIsConnected()) ||
                isAssetArchived(assets[0], archiveResolutions.MID_RES)))
            );
        }
        return !FileInfoUtil.isProject(assets[0]) && containsAnyFolder(assets) || containsAnyProxy(assets);
      }
      return false;
    }
    else return false;
  },
  isShowRemoveFromMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return (isAssetArchived(asset, archiveResolutions.HI_RES) && asset.extraInfo?.isIsConnected()) ||
        isAssetArchived(asset, archiveResolutions.MID_RES);
    })
  },
  isShowHiResRemoveFromMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetArchived(asset, archiveResolutions.HI_RES);
    });
  },
  isShowMidResRemoveFromMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetArchived(asset, archiveResolutions.MID_RES);
    });
  },
  isShowLowResRemoveFromMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetArchived(asset, archiveResolutions.LOW_RES);
    });
  },
  isShowCopyFromMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return (isAssetArchivable(asset, archiveResolutions.HI_RES) && asset.extraInfo?.isIsConnected()) ||
        isAssetArchivable(asset, archiveResolutions.MID_RES);
      //|| isAssetArchivable(asset, archiveResolutions.LOW_RES);
    })
  },
  isShowHiResCopyFromMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetArchivable(asset, archiveResolutions.HI_RES);
    });
  },
  isShowMidResCopyFromMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetArchivable(asset, archiveResolutions.MID_RES);
    });
  },
  isShowLowResCopyFromMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetArchivable(asset, archiveResolutions.LOW_RES);
    });
  },
  isShowCopyToMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return (isAssetArchived(asset, archiveResolutions.HI_RES) && !asset.extraInfo?.isIsConnected()) ||
        isAssetArchived(asset, archiveResolutions.MID_RES);
    })
  },
  isShowHiResCopyToMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetArchived(asset, archiveResolutions.HI_RES);
    });
  },
  isShowMidResCopyToMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetArchived(asset, archiveResolutions.MID_RES);
    });
  },
  isShowLowResCopyToMediaStore: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetArchived(asset, archiveResolutions.LOW_RES);
    });
  },
  isShowCopyFromBackToS3: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetGlacierArchived(asset, archiveResolutions.HI_RES) ||
        isAssetGlacierArchived(asset, archiveResolutions.MID_RES);
    })
  },
  isShowHiResCopyFromBackToS3: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetGlacierArchived(asset, archiveResolutions.HI_RES);
    });
  },
  isShowMidResCopyFromBackToS3: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetGlacierArchived(asset, archiveResolutions.MID_RES);
    });
  },
  isShowLowResCopyFromBackToS3: (args) => {
    return isShowResolutionTabs(args, (asset) => {
      return isAssetGlacierArchived(asset, archiveResolutions.LOW_RES);
    });
  },
  isShowPurge: (args) => {
    const { assets } = args;
    return isAssetOrSearchTabActive() && !FileInfoUtil.isProject(assets[0]) ? true : false;
  },
  isShowArchiveDetailsOption: (args) => {
    const { assets } = args;
    if (System.isDesktop() && isAssetOrSearchTabActive()) {
      if (assets.length === 1) {
        const asset: RepoItem = assets[0];
        if (
          asset.getLowResArchiveStatus() === archiveStatusEnum.VAB_COPIED_TO_ARCHIVE ||
          asset.getMidResArchiveStatus() === archiveStatusEnum.VAB_COPIED_TO_ARCHIVE ||
          asset.getHiResArchiveStatus() === archiveStatusEnum.VAB_COPIED_TO_ARCHIVE ||
          asset.getLowResArchiveStatus() === archiveStatusEnum.COPIED_TO_GLACIER ||
          asset.getMidResArchiveStatus() === archiveStatusEnum.COPIED_TO_GLACIER ||
          asset.getHiResArchiveStatus() === archiveStatusEnum.COPIED_TO_GLACIER ||
          asset.getLowResArchiveStatus() === archiveStatusEnum.VAB_ARCHIVED ||
          asset.getMidResArchiveStatus() === archiveStatusEnum.VAB_ARCHIVED ||
          asset.getHiResArchiveStatus() === archiveStatusEnum.VAB_ARCHIVED
        ) {
          return true;
        } else return false;
      } else return false;
    } else return false
  },

  isShowArchiveRestoreOption: (args) => {
    const { assets } = args;
    if (System.isDesktop() && isAssetOrSearchTabActive()) {
      if (assets.length) {
        if (FileInfoUtil.isProject(assets[0]))
          return false;
        if (assets.length === 1 && !FileInfoUtil.isFolder(assets[0])) {
          const lowResArchiveStatus: string = assets[0].getLowResArchiveStatus();
          const archived: boolean = assets[0].isArchived();
          if (!assets[0].isProxy()) {
            return archived ? true : false;
          } else {
            return (lowResArchiveStatus !== archiveStatusEnum.VAB_NOT_ARCHIVED &&
              lowResArchiveStatus !== archiveStatusEnum.VAB_NOT_APPLICABLE)
              ? true : false;
          }
        } else {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  },

  isCreateBin: (args) => {
    return ViewUtil.isCollectionBrowseTabActive();
  },
  isShowMoveToBin: (args) => {
    return ViewUtil.isCollectionBrowseTabActive();
  },
  isShowRemoveFromBin: (args) => {
    const { collection, selectedCollections } = args;
    let selectedCollection = collection ? collection : (selectedCollections && selectedCollections.length === 1 ? selectedCollections[0] : null);
    return ViewUtil.isCollectionBrowseTabActive() && selectedCollection && selectedCollection.getParentId() > 0;
  },
  canHideCollection: (args) => {
    const { collection, selectedCollections } = args;
    if (selectedCollections.length > 1) {
      for (const collection of selectedCollections) {
        if (CollectionUtil.isArchived(collection.getStatus()) || CollectionUtil.isBinCollection(collection)) {
          return false;
        }
      }
      return true;
    }
    return !CollectionUtil.isArchived(collection.getStatus()) && CollectionUtil.isAssetCollection(collection);
  },

  canUnhideCollection: (args) => {
    const { collection, selectedCollections } = args;
    if (selectedCollections.length > 1) {
      for (const collection of selectedCollections) {
        if (CollectionUtil.isBinCollection(collection))
          return false;
        if (CollectionUtil.isArchived(collection.getStatus()) && CollectionUtil.isAssetCollection(collection)) {
          return true;
        }
      }
    }
    return CollectionUtil.isArchived(collection.getStatus()) && CollectionUtil.isAssetCollection(collection);
  },

  canDeleteCollection: (args) => {
    const { collection, selectedCollections } = args;
    if (selectedCollections.length > 1) {
      for (const collection of selectedCollections) {
        if (!CollectionSettingsUtil.isOwnerOrSuperAdmin(collection) || CollectionUtil.isBinCollection(collection)) {
          return false;
        }
      }
    }
    return CollectionSettingsUtil.isOwnerOrSuperAdmin(collection) && CollectionUtil.isAssetCollection(collection);
  },

  canRenameCollection: (args) => {
    const { collection, selectedCollections } = args;
    if (selectedCollections.length > 1)
      return false;
    if (selectedCollections.length == 1)
      return CollectionSettingsUtil.canRenameCollection(selectedCollections[0]) && CollectionUtil.isAssetCollection(selectedCollections[0]);
    return CollectionSettingsUtil.canRenameCollection(collection) && CollectionUtil.isAssetCollection(collection);
  },

  canDeleteBin: (args) => {
    const { collection, selectedCollections } = args;
    if (selectedCollections.length > 1) {
      for (const collection of selectedCollections) {
        if (!CollectionSettingsUtil.isOwnerOrSuperAdmin(collection) || CollectionUtil.isAssetCollection(collection)) {
          return false;
        }
      }
    }
    return CollectionSettingsUtil.isOwnerOrSuperAdmin(collection) && CollectionUtil.isBinCollection(collection);
  },

  canRenameBin: (args) => {
    const { collection, selectedCollections } = args;
    if (selectedCollections.length > 1)
      return false;
    if (selectedCollections.length == 1)
      return CollectionSettingsUtil.canRenameCollection(selectedCollections[0]) && CollectionUtil.isBinCollection(selectedCollections[0]);
    return CollectionSettingsUtil.canRenameCollection(collection) && CollectionUtil.isBinCollection(collection);
  },
  isShowReactivateBin: (args) => {
    const { collection, selectedCollections } = args;
    if (selectedCollections.length > 1)
      return false;
    if (selectedCollections.length == 1)
      return CollectionUtil.isBinCollection(selectedCollections[0]);
    return CollectionUtil.isBinCollection(collection);
  },
  isShowReactivateCollection: (args) => {
    const { collection, selectedCollections } = args;
    if (selectedCollections.length > 1)
      return false;
    if (selectedCollections.length == 1)
      return !CollectionUtil.isBinCollection(selectedCollections[0]) && MetadataUtil.Collection.isExpired(selectedCollections[0]);
    return !CollectionUtil.isBinCollection(collection) && MetadataUtil.Collection.isExpired(collection);
  },
  isShowDownload: (args) => {
    const { assets } = args;
    return ViewUtil.isCollectionTabActive() && assets.length > 0 ? true : false;
  },

  isShowShareable: (args) => {
    const { assets } = args;
    const assetProps = getAssetProps(assets)
    const { containsDeleted, containsArchived, containsExpired } = assetProps;
    const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
    return isAssetOrSearchTabActive() && !containsNonAliveAsset ? true : false
  },
}